var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemperatureWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon30",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#fff",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "weather-2",
    transform: "translate(8.000000, 3.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weather"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0 C6.15684375,0 7.49998828,1.34314453 7.49998828,2.99998828 L7.49998828,2.99998828 L7.49998828,10.1458477 C8.420625,10.9698047 9,12.1672617 9,13.5 C9,15.9853008 6.98526563,18 4.5,18 C2.01473437,18 0,15.9853008 0,13.5 C0,12.1672617 0.579375,10.9698047 1.50001172,10.1458125 L1.50001172,10.1458125 L1.50001172,2.99998828 C1.50001172,1.34314453 2.84315625,0 4.5,0 Z M4.50001758,6.00001172 C4.08580078,6.00001172 3.75001172,6.33580078 3.75001172,6.75001758 L3.75001172,6.75001758 L3.75076538,11.3777589 C2.87647132,11.68642 2.25,12.5200499 2.25,13.5 C2.25,14.7426407 3.25735931,15.75 4.5,15.75 C5.74264069,15.75 6.75,14.7426407 6.75,13.5 C6.75,12.5204306 6.12401536,11.6870678 5.2502535,11.3781189 L5.2502535,11.3781189 L5.25002344,6.75001758 C5.25002344,6.33580078 4.91423438,6.00001172 4.50001758,6.00001172 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperatureWhite);
export default __webpack_public_path__ + "static/media/icon-temperature-white.7364d8b8465b67c538c0fd8a46f62aaa.svg";
export { ForwardRef as ReactComponent };